/**
 * @file The longest random lag, in milliseconds, between a recompute reaching
 * a page and its analytics answers refetching, so open pages spread their
 * refetches instead of all asking at once. Consumers:
 * `useAnalyticsAnswersRefetch`, which draws each lag below it, and its test.
 */
export const REFETCH_LAG_MAX_MILLIS = 30_000;
